import styled from "styled-components";

export const BatchesContainer = styled.div`
  padding: 30px 24px;
  max-width: 1200px;
  margin: 0 auto 40px;
`;

export const BatchesHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 20px;

  h1 {
    margin: 0;
    font-size: 28px;
    font-weight: 600;
  }

  p {
    margin: 4px 0 0;
    color: #6c757d;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const FiltersContainer = styled.div`
  margin-bottom: 24px;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
`;

export const FiltersForm = styled.form`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-end;
`;

export const FilterField = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
  color: #495057;
  min-width: 200px;
  flex: 1 1 220px;
`;

const baseInputStyles = `
  border: 1px solid #dfe3e8;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  background-color: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  &:focus {
    outline: none;
    border-color: #2f2f2f;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.15);
  }
`;

export const FilterInput = styled.input`
  ${baseInputStyles}
`;

export const FilterSelect = styled.select`
  ${baseInputStyles}
`;

export const FilterButton = styled.button`
  padding: 10px 24px;
  border: none;
  border-radius: 8px;
  background-color: #2f2f2f;
  color: white;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  flex: 0 0 auto;

  &:hover:not(:disabled) {
    background-color: #1a1a1a;
  }

  &:disabled {
    background-color: #dee2e6;
    cursor: not-allowed;
  }
`;

export const Loader = styled.div`
  padding: 8px 16px;
  background-color: rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 6px;
  font-size: 14px;
  color: #2f2f2f;
`;

export const BatchesTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0;
  background-color: white;
  border-radius: 10px 10px 0 0;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  th,
  td {
    padding: 12px 16px;
    text-align: left;
    font-size: 14px;
    border-bottom: 1px solid #f1f3f5;
  }

  th {
    text-transform: uppercase;
    font-size: 12px;
    color: #6c757d;
    background-color: #f8f9fa;
  }
`;

export const BatchRow = styled.tr`
  cursor: pointer;
  background-color: ${({ isSelected }) => (isSelected ? "#f8f9fa" : "white")};

  &:hover {
    background-color: #f8f9fa;
  }
`;

export const InfoBadge = styled.span`
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  background-color: #2f2f2f;
  color: white;
  border-radius: 999px;
  font-size: 12px;
`;

export const SectionTitle = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
`;

export const ConsultationsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0;
  background-color: white;
  border-radius: 10px 10px 0 0;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  th,
  td {
    padding: 12px 16px;
    border-bottom: 1px solid #f1f3f5;
    text-align: left;
  }

  thead {
    background-color: #f8f9fa;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  small {
    color: #6c757d;
    font-size: 12px;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px 24px;
  margin-top: 20px;
  border-radius: 8px;
  background-color: #e9ecef;
  color: #404040;
  font-size: 15px;
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px; /* slightly smaller padding */
  background-color: white;
  border-top: 1px solid #f1f3f5;
  border-radius: 0 0 10px 10px; /* Rounded bottom */
  margin-bottom: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06); /* Same shadow as table */

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const PaginationInfo = styled.div`
  color: #6c757d;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const PaginationControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PageButton = styled.button`
  padding: 6px 12px;
  border: 1px solid #dfe3e8;
  background-color: white;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 13px;
  color: #495057;

  &:hover:not(:disabled) {
    background-color: #f8f9fa;
    border-color: #c4cdd5;
    color: #212529;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: #f1f3f5;
  }
`;

export const PageSizeSelect = styled.select`
  padding: 4px 8px;
  border: 1px solid #dfe3e8;
  border-radius: 6px;
  font-size: 13px;
  background-color: white;
  color: #495057;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #2f2f2f;
  }
`;
